(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vm-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-tabs')) {
    customElements.define(
      'vm-tabs',
      class VmTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(tab, false));
            tab.addEventListener('keydown', (event) => this.onKey(event));
          });
        }

        onKey(event) {
          const index = this.tabs.indexOf(event.currentTarget);
          let next = null;
          if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
          if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          if (event.key === 'Home') next = this.tabs[0];
          if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
          if (next) {
            event.preventDefault();
            this.select(next, true);
          }
        }

        select(tab, focus) {
          this.tabs.forEach((t) => {
            const selected = t === tab;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });
          if (focus) tab.focus();
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vm-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-carousel')) {
    class VmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-counter]');
        if (!this.track) return;
        this.items = Array.from(this.track.children);
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.prevBtn && this.prevBtn.addEventListener('click', () => this.step(-1));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        });
        window.addEventListener('resize', () => this.queueUpdate());
        this.track.setAttribute('tabindex', '0');
        this.update();
      }
      itemWidth() {
        const first = this.items[0];
        if (!first) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      step(dir) {
        this.track.scrollBy({ left: dir * this.itemWidth(), behavior: this.reduced.matches ? 'auto' : 'smooth' });
      }
      queueUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
      }
      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const atStart = t.scrollLeft <= 2;
        const atEnd = t.scrollLeft >= max - 2;
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
        if (this.counter && this.items.length) {
          const idx = Math.min(this.items.length, Math.round(t.scrollLeft / this.itemWidth()) + 1);
          this.counter.textContent = idx + ' / ' + this.items.length;
        }
        this.classList.toggle('vm-reviews--scrollable', max > 4);
      }
    }
    customElements.define('vm-carousel', VmCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vm-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var roots = document.querySelectorAll('[data-vm-story]');
      if (!roots.length) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      roots.forEach(function (root) {
        if (root.classList.contains('vm-story--js') || root.classList.contains('vm-story--static')) return;
        var items = root.querySelectorAll('[data-vm-reveal]');
        if (reduce || !('IntersectionObserver' in window)) {
          root.classList.add('vm-story--static');
          items.forEach(function (el) { el.classList.add('is-in'); });
          return;
        }
        root.classList.add('vm-story--js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        items.forEach(function (el) { io.observe(el); });
      });
    }
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
